import React from "react";
import GravityFieldContainer from "../../gravity-form/field/field-component";
import { errorList, defaultError } from "../../cognito-auth-provider/auth-error-list";

const AuthFormField = ({ error, children, ...props }) => {
    let friendlyError;
    const findError = () => {
        const found = errorList.find(current => error.includes(current.system));
        friendlyError = found ? found.friendly : defaultError;
    };
    error && findError();
    return (
        <GravityFieldContainer {...props} error={friendlyError}>
            {children}
        </GravityFieldContainer>
    );
};

export default AuthFormField;
